// import Vue from 'vue'
import axios from 'axios'
import store from '../store/index'
import { Toast } from 'vant';
import { clearLoginInfo,getTokenParamsObj,getTokenPath} from './index'
var httpTimeId
var isShowErrorDialog = false

const http = axios.create({
  timeout: 1000 * 60 * 10,
  withCredentials: true
})


/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  if(config.url == '/api/sys/login') return config
  // if (global.noTokenUrl.indexOf(config.url) > -1 || config.url.indexOf('/api/sys/validate/image/code/') > -1 || config.url.indexOf('/api/sys/get/userMobile') > -1 || config.url.indexOf('/api/sys/forget/password') > -1) return config
  config.headers['token'] = store.state.token // 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use((response) => {
  switch (response.data.code) {
    case 5000:
      Toast(response.data.msg ? response.data.msg : '会话已经过时，刷新页面');
      break
    case 401:
      Toast(response.data.msg ? response.data.msg : '会话已经过时，刷新页面');
      break
  }
  if (response.data.code && response.data.code !== 200) {
    let errorMsg = response.data.msg ? response.data.msg : response.data.data.msg ? response.data.data.msg : response.data.data ? response.data.data : global.errorMsg
    if (errorMsg == '系统异常' || errorMsg == '系统发生了异常' || errorMsg.indexOf('Exception') > -1 || errorMsg.indexOf('exception') > -1) {
      Toast('服务器出了点小差，请稍后再试')
    } else {
      if(response.config.customSuccess){
        return response
      }else{
        Toast(errorMsg?errorMsg:'服务器出了点小差，请稍后再试')
      }
    }
  } else {
    return response
  }
}, error => {
  console.log(error)
  switch (error.response.status) {
    case 400:
      Toast(error.response.data)
      // initMessageBox(error.response.data)
      break
    case 401:
      Toast(error.response.data)
      clearLoginInfo()
      break
    case 405:
      Toast('http请求方式有误')
      break
    case 500:
      Toast('服务器出了点小差，请稍后再试')
      break
    case 501:
      Toast('服务器不支持当前请求所需要的某个功能')
      break
  }
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
//  return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/proxyApi' : window.SITE_CONFIG.baseUrl) + actionName
  return (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/proxyApi' : window.SITE_CONFIG.baseUrl) + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    't': new Date().getTime()
  }
  return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
// http.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
//   var defaults = {
//     't': new Date().getTime()
//   }
//   data = openDefultdata ? merge(defaults, data) : data
//   return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
// }

export default http
